export enum AppRoutes {
  Base = '/',
  BetterHealth = '/betterhealth',
  ShidoQR = '/shido-qr',
  Invitation = '/invite/:month',
  Corporate = '/:account',
  CorporateBase = '/corporate/:account',
  CorporateOnboarding = 'onboarding',
  CorporateSuccess = 'success',
  PromotionBase = '/promotion',
  PromotionActivation = ':publicCode/activate',
  PromotionOffer = ':promotionTerm/:code',
  AffiliateBase = '/affiliate',
  AffiliateOffer = ':code',
  AffiliateActivate = 'activate',
  AffiliateQR = ':emailVerificationCode',
  AffiliateInstruction = 'offer/instruction',
}

export const routes = {
  [AppRoutes.Corporate]: (account: string) => `/${account}`,
  [AppRoutes.CorporateOnboarding]: (account: string) =>
    `/corporate/${account}/${AppRoutes.CorporateOnboarding}`,
  [AppRoutes.CorporateSuccess]: (account: string) =>
    `/corporate/${account}/${AppRoutes.CorporateSuccess}`,
};
